import { useQuery } from "@tanstack/react-query";
import { getCategories, type CategoriesResponse } from "../api/categories/get-categories";

export function useCategories(limit = 1000) {
    return useQuery<CategoriesResponse>({
        queryKey: ["categories"],
        queryFn: () => getCategories(limit),
        staleTime: 1000 * 30,
        gcTime: 1000 * 60 * 10,
        refetchOnWindowFocus: true,
        refetchInterval: 60 * 1000,
    });
}


